import { deleteDraft } from './deleteDraft/deleteDraft';
import getDraft from './getDraft';
import { sendDraft } from './sendDraft/sendDraft';

export default {
  deleteDraft,
  getDraft,
  sendDraft,
};
